import React from "react";
import cn from "classnames";
import styles from "./colored-toggle-button.module.scss";

interface ToggleButtonPropTypes {
  isActive: boolean;
  handleClick: () => void;
  variant?: "blue" | "green" | "orange" | "red";
  disabled?: boolean;
}

export const ColoredToggleButton = ({
  isActive,
  handleClick,
  variant = "blue",
  disabled = false,
}: ToggleButtonPropTypes) => {
  const base = "colored-toggle-button";

  return (
    <button
      disabled={disabled}
      className={cn(styles[base], {
        [styles[`${base}--${variant}`]]: variant,
      })}
      onClick={handleClick}
    >
      <span
        className={cn(styles[`${base}__circle`], {
          [styles[`${base}__circle--active`]]: isActive,
        })}
      />
    </button>
  );
};
